import axios from "axios";

export default {
  isUserGuest() {
    return localStorage.getItem('accessToken') === null;
  },
  authUrl(url) {

    axios.get(process.env.VUE_APP_ROOT_API + url).then((response) => {
      console.log(response.data)
      if (response.data.success) {
        window.location.href = response.data.data.url;
      }
    });
  },
  clearLocalStorage() {
    localStorage.removeItem('profile');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  },
  setLocalStorage(params) {
    localStorage.setItem('profile', JSON.stringify(params.profile));
    localStorage.setItem('accessToken', params.accessToken);
    localStorage.setItem('refreshToken', params.refreshToken);
  },
  Logout() {
    this.clearLocalStorage();
    this.$router.push({name: 'home'});
  }
}
